import type React from 'react'
import type { IconProps } from '@/types'

export const ChatIcon: React.FC<IconProps> = ({ className = 'h-5 w-5', size }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      height={size}
      width={size}
    >
      <title>Chat</title>
      <path
        d="M4.5 18h-0.75a3 3 0 0 1 -3 -3v-3a3 3 0 0 1 3 -3h0.75a0.75 0.75 0 0 1 0.75 0.75v7.5a0.75 0.75 0 0 1 -0.75 0.75Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.25 18h-0.75a0.75 0.75 0 0 1 -0.75 -0.75v-7.5A0.75 0.75 0 0 1 19.5 9h0.75a3 3 0 0 1 3 3v3a3 3 0 0 1 -3 3Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3.75 9A8.25 8.25 0 0 1 12 0.75h0A8.25 8.25 0 0 1 20.25 9"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15 21.75h2.25a3 3 0 0 0 3 -3h0V18"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.5 23.25H12a1.5 1.5 0 0 1 -1.5 -1.5h0a1.5 1.5 0 0 1 1.5 -1.5h1.5a1.5 1.5 0 0 1 1.5 1.5h0a1.5 1.5 0 0 1 -1.5 1.5Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
